
    import { defineComponent, computed, PropType, ref, watch } from 'vue'
    import MessageAudio from './ReplyAudio.vue'
    import MessageButton from './ReplyButton.vue'
    import MessageFile from './ReplyFile.vue'
    import MessageImage from './ReplyImage.vue'
    import MessageText from './ReplyText.vue'
    import MessageVideo from './ReplyVideo.vue'

    import { Reply, isComponents, KeysReplyContentType, ValuesReplyContentType } from '@/types/message'

    export default defineComponent({
        components: {
            MessageAudio, MessageButton, MessageFile, MessageImage, MessageText, MessageVideo
        },

        props: {
            modelValue: {
                type: Object as PropType<Reply>,
                default: () => ({})
            }
        },

        setup (props) {
            const state = ref<Reply>(props.modelValue)
            const isComponent = computed(() => {
                if (state.value?.content?.type) {
                    return getReplyComponent(state.value.content.type)
                } else {
                    return 'MessageText'
                }
            })

            watch(() => props.modelValue, (newValue) => {
                state.value = newValue
            })

            function getReplyComponent (messageType: KeysReplyContentType): ValuesReplyContentType {
                return isComponents[messageType] ?? 'MessageText'
            }

            function anchorReply (messageId: string): void {
                const el = document.getElementById(messageId)
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'center' })
                }
            }
            return {
                state,
                isComponent,
                anchorReply
            }
        }
    })
